import { render, staticRenderFns } from "./Cti.vue?vue&type=template&id=606197ed&scoped=true&"
import script from "./Cti.vue?vue&type=script&lang=js&"
export * from "./Cti.vue?vue&type=script&lang=js&"
import style0 from "./Cti.vue?vue&type=style&index=0&id=606197ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606197ed",
  null
  
)

export default component.exports